import { render } from "./CheckedIcon.vue?vue&type=template&id=54e353ca"
import script from "./CheckedIcon.vue?vue&type=script&lang=js"
export * from "./CheckedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__